export default __webpack_public_path__ + "static/media/block.6da3896d.svg";